import Api from "@/api/index";
const errors = {
  namespaced: true,
  state: {
    errors: {},
    valid_count: 0,
    invalid_count: 0,
  },
  getters: {
    getErrors(state) {
      return state.errors;
    },
  },
  mutations: {
    SET_ERRORS(state, datas) {
      state.errors = datas;
    },
    SET_VALID_COUNT(state, datas) {
      state.valid_count = datas;
    },
    SET_INVALID_COUNT(state, datas) {
      state.invalid_count = datas;
    },
  },
  actions: {
    async setValidCount({ commit }, payload) {
      commit("SET_VALID_COUNT", payload);
    },
    async setInvalidCount({ commit }, payload) {
      commit("SET_INVALID_COUNT", payload);
    },
    async setError({ commit }, payload) {
      commit("SET_ERRORS", payload);
    },
    removeError({ state }, payload) {
      state.errors[payload] = [];
    },
    async clearErrors({ commit }) {
      commit("SET_ERRORS", {});
    },
  },
};

export default errors;
